import {onFind} from "@elements/init-modules-in-scope";
import {on, findIn, findAllIn} from "@elements/dom-utils";
import formDataEntries from 'form-data-entries';

const selectors = {
    base: '.js-ajax-load-more',
    form: '.js-ajax-load-more__form',
    btn: '.js-ajax-load-more__btn',
    content: '.js-ajax-load-more__content',
    items: '.js-ajax-load-more__item',
    input: '.js-ajax-load-more__input',
    loading: '.js-ajax-load-more__loading',
    error: '.js-ajax-load-more__error'
};

export function init() {
    onFind(selectors.base, (base) => {
        let form = findIn(selectors.form, base);
        let btn = findIn(selectors.btn, base);
        let input = findIn(selectors.input, form);
        let loading = findIn(selectors.loading, base);

        on("click", (event) => {
            event.preventDefault();

            loading.removeAttribute('hidden');

            let content = findIn(selectors.content, base);
            let errorMessage = findIn(selectors.error, base);
            let items = findAllIn(selectors.items, form);
            let lastItem = items.slice(-1)[0];
            let lastItemId = lastItem.getAttribute('data-list-id');
            input.setAttribute('value', lastItemId);

            let url = form.getAttribute('data-action');
            let formContent = form;
            let data = new URLSearchParams(formDataEntries(formContent));

            if (pendingRequest) {
                pendingRequest.abort();
                pendingRequest = null;
            }

            let pendingRequest = fetch( url, {
                method: "POST",
                body: data
            } );

            pendingRequest.then((res) => {
                return res.clone().json()
            }).then((res) => {

                if (res.success) {
                    let newContent= document.createElement('tbody');
                    newContent.innerHTML = res.html;

                    content.appendChild(newContent);
                }else{
                    console.log("no success")

                    errorMessage.removeAttribute('hidden');
                    errorMessage.innerHtml = res.message;
                }

                loading.setAttribute('hidden', true);

            }).catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error(error);

                    errorMessage.removeAttribute('hidden');

                    loading.setAttribute('hidden', true);
                }
            });
        }, btn);
    });
}
